import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setRecurringMeeting, setCalendarMeeting } from 'Shared/actions/workspaces';
import ConfirmModal from 'Shared/components/ConfirmModal/ConfirmModal';

type Props = {
  onToggle: (event: React.MouseEvent<HTMLInputElement>) => void;
  isRecurringMeeting: boolean;
};

function UnsyncMeetingModal({ onToggle, isRecurringMeeting }: Props) {
  const dispatch = useDispatch();
  const workspaceId = useSelector(state => state.workspace.id);

  const handleUnsyncClick = useCallback(
    event => {
      if (isRecurringMeeting) dispatch(setRecurringMeeting({ recurringMeeting: null, workspaceId, page: 'workspace' }));
      if (!isRecurringMeeting) dispatch(setCalendarMeeting({ calendarMeeting: null, workspaceId, page: 'workspace' }));
      onToggle(event);
    },
    [workspaceId, onToggle, dispatch]
  );

  return (
    <ConfirmModal isOpen onToggle={onToggle} onConfirmClick={handleUnsyncClick} confirmButtonLabel="Yes, Unsync">
      <span className="font-weight-bold">Are you sure you want to unsync this meeting with this workspace? </span>
      <br />
      <br />
      You will no longer receive notifications tied to this meeting.
    </ConfirmModal>
  );
}

export default UnsyncMeetingModal;
